import React, { memo } from 'react';
import styled from 'styled-components';
import { companyInfo } from '@mocks/sample-data';

import cn from 'classnames';
import {
  EVENT_CLASS_NAME,
  EVENT_ACTION_NAME,
  EVENT_CATEGORY,
  EVENT_LABEL,
} from '@helpers/events';
import ZaloIcon from '@views/static/zalo.svg';

const PhoneIcon =
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHZpZXdCb3g9IjAgMCA0MCA0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTg1NCAtNTEyLjk3KSI+PGNpcmNsZSB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODU0IDUxMi45NykiIGN4PSIyMCIgY3k9IjIwIiByPSIyMCIgZmlsbD0iI2ZmNjcyZiIgZGF0YS1uYW1lPSJFbGxpcHNlIDEzMSIvPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NjQuNyA1MjIuMzIpIiBkYXRhLW5hbWU9Ikdyb3VwIDE4NzgiPjxwYXRoIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yLjU3MSAtMy44NTYpIiBkPSJtMTguMTk0IDE2LjYzOWMtMS40MiAxLjQyLTEuNDIgMi44NDEtMi44NDEgMi44NDFzLTIuODQxLTEuNDItNC4yNjEtMi44NDEtMi44NC0yLjgzOS0yLjg0LTQuMjYxIDEuNDItMS40MiAyLjg0MS0yLjg0MS0yLjg0MS01LjY4MS00LjI2MS01LjY4MS00LjI2MSA0LjI2MS00LjI2MSA0LjI2MWMwIDIuODQxIDIuOTE4IDguNiA1LjY4MSAxMS4zNjJzOC41MjIgNS42ODEgMTEuMzYyIDUuNjgxYzAgMCA0LjI2MS0yLjg0MSA0LjI2MS00LjI2MXMtNC4yNjEtNS42ODEtNS42ODEtNC4yNnoiIGZpbGw9IiNmZmYiIGRhdGEtbmFtZT0iSWNvbiBtZXRyby1waG9uZSIvPjwvZz48L2c+PC9zdmc+';
const PhoneContainer = styled.div`
  position: fixed;
  right: 25px;
  bottom: 90px;
  z-index: 9192;
  background: linear-gradient(90deg, #f53d2d, #f63);
  padding: 10px;
  color: var(--white);
  border-radius: 50%;
  display: flex;
  align-items: center;
  transition: all 1s ease-out;
  &:hover {
    border-radius: 64px;
    .phone-number {
      display: inline-block;
    }
  }

  .phone-number {
    color: var(--white);
    font-size: 1.125rem;
    font-weight: 500;
    padding: 0 0.5rem;
    display: none;
    width: 130px;

    @media (max-width: 768px) {
      display: none;
    }
  }

  .phone-icon {
    // animation: shake 1s infinite ease-in-out;
    width: 40px;
    height: 40px;
    background: url(${PhoneIcon}) center center no-repeat;
    background-position: 100%;
    display: block;
  }
`;

const MessagerContainer = styled.div`
  // animation: 3s ease-out 0s 1 normal none running slideInFromBottomDelay;
  background: none;
  bottom: 24px;
  display: block;
  margin: 0px 12px;
  overflow: visible;
  padding: 0px;
  position: fixed;
  top: auto;
  z-index: 2147483644;
  border-radius: 30px;
  box-shadow: rgb(0 0 0 / 15%) 0px 4px 12px 0px;
  height: 60px;
  width: 60px;
  right: 12px;
`;

const ZaloContainer = styled.div`
  background: none;
  bottom: 158px;
  display: block;
  margin: 0px 12px;
  overflow: visible;
  padding: 0px;
  position: fixed;
  top: auto;
  z-index: 2147483644;
  border-radius: 30px;
  height: 56px;
  width: 56px;
  right: 18px;
`;

const MessengerIcon = memo(() => (
  <svg x="0" y="0" width="60px" height="60px">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <circle fill="#0A7CFF" cx="30" cy="30" r="30"></circle>
        <svg x="10" y="10">
          <g transform="translate(0.000000, -10.000000)" fill="#FFFFFF">
            <g id="logo" transform="translate(0.000000, 10.000000)">
              <path d="M20,0 C31.2666,0 40,8.2528 40,19.4 C40,30.5472 31.2666,38.8 20,38.8 C17.9763,38.8 16.0348,38.5327 14.2106,38.0311 C13.856,37.9335 13.4789,37.9612 13.1424,38.1098 L9.1727,39.8621 C8.1343,40.3205 6.9621,39.5819 6.9273,38.4474 L6.8184,34.8894 C6.805,34.4513 6.6078,34.0414 6.2811,33.7492 C2.3896,30.2691 0,25.2307 0,19.4 C0,8.2528 8.7334,0 20,0 Z M7.99009,25.07344 C7.42629,25.96794 8.52579,26.97594 9.36809,26.33674 L15.67879,21.54734 C16.10569,21.22334 16.69559,21.22164 17.12429,21.54314 L21.79709,25.04774 C23.19919,26.09944 25.20039,25.73014 26.13499,24.24744 L32.00999,14.92654 C32.57369,14.03204 31.47419,13.02404 30.63189,13.66324 L24.32119,18.45264 C23.89429,18.77664 23.30439,18.77834 22.87569,18.45674 L18.20299,14.95224 C16.80079,13.90064 14.79959,14.26984 13.86509,15.75264 L7.99009,25.07344 Z"></path>
            </g>
          </g>
        </svg>
      </g>
    </g>
  </svg>
));

const PhoneCallButton = memo(() => {
  return (
    <>
      <ZaloContainer>
        <a
          aria-label={companyInfo.name}
          title={companyInfo.name}
          href={companyInfo.zalo}
          className={cn(EVENT_CLASS_NAME)}
          data-category={EVENT_CATEGORY.ACTION}
          data-action={EVENT_ACTION_NAME}
          data-label={EVENT_LABEL.CHAT_ACTION}
          target="_blank"
          rel="noopener noreferrer"
        >
          <ZaloIcon />
        </a>
      </ZaloContainer>
      <PhoneContainer>
        <a
          aria-label={companyInfo.phone}
          title={companyInfo.phone}
          href={`tel: ${companyInfo.phone}`}
          className={cn(EVENT_CLASS_NAME)}
          data-category={EVENT_CATEGORY.ACTION}
          data-action={EVENT_ACTION_NAME}
          data-label={EVENT_LABEL.HOT_PHONE_ACTION}
        >
          <span className="phone-icon" />
        </a>
        <span className="phone-number">{companyInfo.phone}</span>
      </PhoneContainer>
      <MessagerContainer>
        <a
          aria-label={companyInfo.facebook}
          title={companyInfo.facebook}
          href={companyInfo.facebook}
          className={cn(EVENT_CLASS_NAME)}
          data-category={EVENT_CATEGORY.ACTION}
          data-action={EVENT_ACTION_NAME}
          data-label={EVENT_LABEL.CHAT_ACTION}
          target="_blank"
          rel="noopener noreferrer"
        >
          <MessengerIcon />
        </a>
      </MessagerContainer>
    </>
  );
});

export default PhoneCallButton;
